import { useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Mapir from "mapir-react-component";
import Map from "../../../../services/map";
import Card from "../../../../components/card";
import { FullScreen } from "../../../../components/dialog";
import markerImg from "../../../../assets/images/icon/marker.png";
import { ButtonBox, Div } from "./style";
import Form from "./Form";
import { Marker, MarkerImg } from "./style";

const MapAddress = (props) => {
  const { data, theme, refrence, addresses, setAddresses } = props;

  const createFromAddressRef = useRef();

  const [state, setState] = useState({
    addressData: false,
    coordinates: {
      lat: data?.lat ? data?.lat : 31.836809417811537,
      lon: data?.lng ? data?.lng : 54.37182323095445,
    },
  });

  const setAddressesData = useCallback(() => {
    var newAddressData = {
      target: {
        transform: {
          _center: {
            lat: state.coordinates.lat,
            lng: state.coordinates.lon,
          },
        },
      },
    };

    onDrag(false, newAddressData);
  }, []);

  useEffect(() => {
    setAddressesData();
  }, [setAddressesData]);

  const showCreateForm = (e) => {
    e.preventDefault();

    createFromAddressRef.current.changeStatus();
  };

  const onDrag = (e, mapData) => {
    var url = `https://map.ir/reverse/no?lat=${mapData.target.transform._center.lat}&lon=${mapData.target.transform._center.lng}`;

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key":
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE5YjA2ODBkODYyMGJjZDA1NTVmZTI2MTU0ZmNhMzZjN2JhZDczM2UwNWU4YzNkZGMzYWI4OTY2Njc5OTE1ODNkODE4NzM1MGYxMWFjYjUzIn0.eyJhdWQiOiIxMzc2MCIsImp0aSI6ImE5YjA2ODBkODYyMGJjZDA1NTVmZTI2MTU0ZmNhMzZjN2JhZDczM2UwNWU4YzNkZGMzYWI4OTY2Njc5OTE1ODNkODE4NzM1MGYxMWFjYjUzIiwiaWF0IjoxNjE5NjE2MjQ2LCJuYmYiOjE2MTk2MTYyNDYsImV4cCI6MTYyMjIwODI0Niwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.EoyIafo7XIcscez5x5BO7J3mXHdYUg2Vl8sND8Ge401-ACVJDORupfhP_bzj4NomftRii98NglQUQa6ym_3WQi3XubJBvUNkxinHfXUJ8q9sltU382rSyzj7AOBCdIlgqR8M1by1Q48cf6fsrhzMwTWlFDhZxUBMQPTtRtUY1dlolABTYhEuQamRibmMKUOJZrQH4nfxMuiKwM19xTxc2Zv-hf5aCk9sbMBEfNXmeUTpPo9-86tH5PahGnAJQbr_Kv17kaA7_HBHPWXweWXpwC_xHqsodXjYeL-M3VCjTTwVzefkjcQs_b0xPKyrHqZzBH2Uc8VY0CI9C_n4p-kYIA",
      },
    })
      .then((response) => response.json())
      .then((dataRes) => {
        setState({
          addressData: dataRes,
          coordinates: {
            lat: mapData.target.transform._center.lat,
            lon: mapData.target.transform._center.lng,
          },
        });
      })
      .catch((error) => {
        setState({
          ...state,
          coordinates: {
            lat: mapData.target.transform._center.lat,
            lon: mapData.target.transform._center.lng,
          },
        });
      })
      .finally(() => {});
  };

  return (
    <>
      <Form
        refrence={createFromAddressRef}
        mapRef={refrence}
        data={state.addressData}
        address={data}
        addresses={addresses}
        setAddresses={setAddresses}
      />
      <FullScreen title="ویرایش موقعیت" ref={refrence}>
        <Mapir
          center={[state.coordinates.lon, state.coordinates.lat]}
          Map={Map}
          userLocation
          containerStyle={{ height: window.innerHeight - 50 }}
          onMoveEnd={onDrag}
        >
          <Mapir.RotationControl />
          <Mapir.ZoomControl position={"top-left"} />
        </Mapir>
        {state.addressData && (
          <ButtonBox>
            <Card className="p-2 py-3 box-shadow-unset">
              <Div className="float-right w-75 text-right" theme={theme}>
                <i className="fal fa-map-marker-alt f-18 vertical-align-sub ml-1 color-app"></i>
                {state.addressData?.address_compact}
              </Div>
              <a
                href="/"
                className="btn btn-info f-11 w-25"
                onClick={(e) => showCreateForm(e)}
              >
                ثبت موقعیت
              </a>
            </Card>
          </ButtonBox>
        )}
        <Marker>
          <MarkerImg src={markerImg} height="30" />
        </Marker>
      </FullScreen>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.theme,
  };
};

export default connect(mapStateToProps, false)(MapAddress);
